import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


function pathControlCoupons(couponId=null) {
  if (couponId) {
      return `control/coupons/${couponId}`;
  } else {
      return `control/coupons`;
  }
}

export function createControlCoupons(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlCoupons(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchControlCoupons(successCallback, errorCallback, data, couponId) {
  patchAuth({
    "path": pathControlCoupons(couponId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlCoupons(successCallback, errorCallback, couponId) {
  deleteAuth({
    "path": pathControlCoupons(couponId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlManageCoupons(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-coupons`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

